<template>
    <Modal>
        <template #header>
            <h2 class="title is-5">{{ $t('modals.time_range.alarm') }}</h2>
        </template>

        <div class="container">
            <div class="timepicker-wrapper">
                <b-timepicker v-model="alarm.from" inline mobile-native size="is-small"></b-timepicker>
                <span class="timepicker-dash">-</span>
                <b-timepicker v-model="alarm.to" inline size="is-small"></b-timepicker>
            </div>
        </div>

        <template #footer>
            <div class="container w-100 is-fluid">
            <div class="columns is-desktop is-mobile has-text-centered">
                <div class="column is-half" style="padding-right: 25px;">
                    <b-button class="is-fullwidth" @click="$parent.close()">{{ $t('modals.time_range.cancel') }}</b-button>
                </div>
                <div class="column is-half" style="padding-left: 25px;">
                    <b-button class="is-fullwidth is-primary" @click="$emit('save')">{{ $t('modals.time_range.save') }}</b-button>
                </div>
            </div>
            </div>
        </template>

    </Modal>
</template>

<script>
import Modal from './Modal';
export default {
    name: 'TimeRangeModal',
    props: ['alarm'],
    components: { Modal }
};
</script>

<style lang="scss">
    .modal .animation-content {
        width: 100%;
        height: 100%;
        margin: 0;

        .modal-card {
            height: 100%;
            .modal-card-body {
                display: flex;
                align-items: center;
            }
        }

        .modal-close {
            top: 17px;
            right: 15px;
        }
    }
</style>
